<footer class="footer ">
  <div class="container-fluid py-0">
    <div class="row">
      <div class="col-md-8 footer-copyright text-end mb-0">
        <p class="mb-0">Copyright <span class="year-update">© {{ getCurrentYear() }} </span> AeroVera IQ, Inc. - All Rights Reserved.
        </p>
       
      </div>
      <div class="col-md-4 text-end mb-0">
        <p class="mb-0">Version 1.1.0</p>
      </div>
    </div>
  </div>
</footer>
